import React, { useEffect, useState } from "react";
import { generateXZReportData } from "../../data/reports";
import { printHtml } from "../../data/print";

const XReportView = ({ onClose, businessUnit = "alimentation" }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [range, setRange] = useState("session"); // "session", "today", "yesterday", "week", "month"

  useEffect(() => {
    let isMounted = true;
    setLoading(true);

    let from = null;
    let to = null;
    const now = new Date();

    if (range === "today") {
      from = new Date(now.getFullYear(), now.getMonth(), now.getDate()).toISOString();
      to = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59).toISOString();
    } else if (range === "yesterday") {
      from = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1).toISOString();
      to = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 23, 59, 59).toISOString();
    } else if (range === "week") {
      const day = now.getDay() || 7; // Get current day number, converting Sun. to 7
      from = new Date(now.getFullYear(), now.getMonth(), now.getDate() - day + 1).toISOString();
      to = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59).toISOString();
    } else if (range === "month") {
      from = new Date(now.getFullYear(), now.getMonth(), 1).toISOString();
      to = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59).toISOString();
    }

const fetchArgs = range === "session" ? {} : { from, to };

    generateXZReportData({ ...fetchArgs, unit: businessUnit }).then(report => {
      if (isMounted) {
        setData(report);
        setLoading(false);
      }
    }).catch(() => {
      if (isMounted) setLoading(false);
    });
    return () => { isMounted = false; };
  }, [range, businessUnit]);

  const handlePrint = () => {
    if (!data) return;
    
    // Very simple thermal print format for X Report
    const html = `
      <div style="font-family: monospace; width: 300px; padding: 10px; font-size: 14px;">
        <h2 style="text-align: center; margin: 0 0 10px 0;">ÉTAT (X)</h2>
        <div style="text-align: center; margin-bottom: 20px;">
          ${new Date().toLocaleString("fr-FR")}
        </div>
        
        <div style="border-bottom: 1px dashed #000; margin-bottom: 10px;"></div>
        
        <div style="display: flex; justify-content: space-between;">
          <span>Ventes HT/TTC:</span>
          <span>${data.totalSalesRevenue.toFixed(2)} €</span>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <span>Nb Tickets:</span>
          <span>${data.totalSalesCount}</span>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <span>Panier Moyen:</span>
          <span>${data.totalSalesCount > 0 ? (data.totalSalesRevenue / data.totalSalesCount).toFixed(2) : "0.00"} €</span>
        </div>

        <div style="border-bottom: 1px dashed #000; margin: 10px 0;"></div>
        <div style="border-bottom: 1px dashed #000; margin: 10px 0;"></div>
        <h4 style="margin: 0 0 5px 0;">Modes de Consommation</h4>
        <div style="display: flex; justify-content: space-between;">
          <span>En Magasin:</span>
          <span>${data.orderModeBreakdown.magasin.toFixed(2)} €</span>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <span>À Emporter:</span>
          <span>${data.orderModeBreakdown.emporter.toFixed(2)} €</span>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <span>Livraison:</span>
          <span>${data.orderModeBreakdown.livrer.toFixed(2)} €</span>
        </div>

        <div style="border-bottom: 1px dashed #000; margin: 10px 0;"></div>
        <h4 style="margin: 0 0 5px 0;">Règlements</h4>
        ${Object.entries(data.paymentBreakdown).map(([method, amount]) => `
          <div style="display: flex; justify-content: space-between;">
            <span>${method}:</span>
            <span>${amount.toFixed(2)} €</span>
          </div>
        `).join('')}

        <div style="border-bottom: 1px dashed #000; margin: 10px 0;"></div>
        <h4 style="margin: 0 0 5px 0;">Caisse</h4>
        <div style="display: flex; justify-content: space-between;">
          <span>Fond de caisse (ouv):</span>
          <span>${data.openingFloat.toFixed(2)} €</span>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <span>Apports (+):</span>
          <span>${(data.cashMovementsIn - data.openingFloat).toFixed(2)} €</span>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <span>Retraits (-):</span>
          <span>${data.cashMovementsOut.toFixed(2)} €</span>
        </div>
        <div style="display: flex; justify-content: space-between; font-weight: bold; margin-top: 5px;">
          <span>TOTAL ATTENDU:</span>
          <span>${data.expectedCash.toFixed(2)} €</span>
        </div>
        
        <div style="border-bottom: 1px dashed #000; margin: 10px 0;"></div>
        <div style="display: flex; justify-content: space-between;">
          <span>Retours / Avoirs:</span>
          <span>${data.totalReturnsCount} (-${data.totalReturnsRevenue.toFixed(2)} €)</span>
        </div>

        <div style="text-align: center; margin-top: 30px; font-size: 12px;">
          -- FIN DU RAPPORT X --
        </div>
      </div>
    `;
    printHtml(html);
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center h-100 w-100 text-white">
        <div className="spinner-border text-light" role="status"></div>
      </div>
    );
  }

  return (
    <div className="card shadow-sm border-0 h-100" style={{ backgroundColor: "#1f2937", color: "white" }}>
      <div className="card-header border-bottom-0 pb-0 bg-transparent pt-4 d-flex justify-content-between align-items-center">
        <h5 className="fw-bold m-0">
              <i className="bi bi-file-earmark-text me-2"></i>
              ÉTAT (X) - Lecture seule
              {businessUnit === "traiteur" && (
                <span className="ms-2 badge" style={{ backgroundColor: "#f97316", fontSize: "0.7rem" }}>TRAITEUR</span>
              )}
            </h5>
        <button className="btn btn-sm btn-outline-light" onClick={onClose}><i className="bi bi-x-lg"></i></button>
      </div>
      <div className="card-body" style={{ overflowY: "auto" }}>
        
        <div className="mb-4 d-flex justify-content-between align-items-center bg-dark p-2 rounded">
          <span className="small text-muted fw-bold">Période :</span>
          <select 
            className="form-select form-select-sm bg-secondary text-white border-secondary w-auto"
            value={range}
            onChange={(e) => setRange(e.target.value)}
          >
            <option value="session">Cette session</option>
            <option value="today">Aujourd'hui</option>
            <option value="yesterday">Hier</option>
            <option value="week">Cette semaine</option>
            <option value="month">Ce mois</option>
          </select>
        </div>

        <div className="row g-3 mb-4">
          <div className="col-6">
            <div className="p-3 rounded" style={{ backgroundColor: "#374151" }}>
              <div className="small opacity-75">Ventes (CA)</div>
              <div className="fs-4 fw-bold text-success">{data.totalSalesRevenue.toFixed(2)} €</div>
              <div className="small">{data.totalSalesCount} tickets</div>
            </div>
          </div>
          <div className="col-6">
            <div className="p-3 rounded" style={{ backgroundColor: "#374151" }}>
              <div className="small opacity-75">Espèces Attendu</div>
              <div className="fs-4 fw-bold text-info">{data.expectedCash.toFixed(2)} €</div>
              <div className="small">F.D.C: {data.openingFloat.toFixed(2)} €</div>
            </div>
          </div>
        </div>

        <h6 className="border-bottom pb-2 mb-3 border-secondary text-white">Modes de Consommation</h6>
        <div className="d-flex justify-content-between mb-2">
          <span>En Magasin</span>
          <span className="fw-bold">{data.orderModeBreakdown.magasin.toFixed(2)} €</span>
        </div>
        <div className="d-flex justify-content-between mb-2">
          <span>À Emporter</span>
          <span className="fw-bold">{data.orderModeBreakdown.emporter.toFixed(2)} €</span>
        </div>
        <div className="d-flex justify-content-between mb-2">
          <span>En Livraison</span>
          <span className="fw-bold">{data.orderModeBreakdown.livrer.toFixed(2)} €</span>
        </div>

        <h6 className="border-bottom pb-2 mb-3 mt-4 border-secondary text-white">Répartition des encaissements</h6>
        {Object.entries(data.paymentBreakdown).map(([method, amount]) => (
          <div key={method} className="d-flex justify-content-between mb-2">
            <span>{method}</span>
            <span className="fw-bold">{amount.toFixed(2)} €</span>
          </div>
        ))}

        <h6 className="border-bottom pb-2 mb-3 mt-4 border-secondary text-white">Mouvements de Caisse</h6>
        <div className="d-flex justify-content-between mb-2">
          <span>Apports & Divers (+)</span>
          <span className="text-success fw-bold">{(data.cashMovementsIn - data.openingFloat).toFixed(2)} €</span>
        </div>
        <div className="d-flex justify-content-between mb-2">
          <span>Retraits & Prélèvements (-)</span>
          <span className="text-danger fw-bold">-{data.cashMovementsOut.toFixed(2)} €</span>
        </div>

        {data.totalReturnsCount > 0 && (
          <>
            <h6 className="border-bottom pb-2 mb-3 mt-4 border-secondary text-white">Retours & Remboursements</h6>
            <div className="d-flex justify-content-between mb-2 text-warning">
              <span>{data.totalReturnsCount} Avoir(s) / Retour(s)</span>
              <span className="fw-bold">-{data.totalReturnsRevenue.toFixed(2)} €</span>
            </div>
          </>
        )}

      </div>
      <div className="card-footer border-top-0 pt-0 bg-transparent pb-4 d-flex gap-2">
        <button className="btn fw-bold flex-grow-1" style={{ backgroundColor: "#3b82f6", color: "white" }} onClick={handlePrint}>
          <i className="bi bi-printer me-2"></i> IMPRIMER LE TICKET (X)
        </button>
      </div>
    </div>
  );
};

export default XReportView;


